'use strict';
import { CurationDashboardOperations } from './curation-dashboard-interface';
import { IcurationWorklistItem } from '../../../interfaces/curation-worklist-item.interface';
import { CurationUtils } from '../../../utils/curation-utils';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CurationSettings } from '../curation-setting';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';

@Injectable()
export class curationDashboardWorklistService implements CurationDashboardOperations {
  getCurationItem(curationItemId, revisionId, type) {
  }
  openEditorParams(response: any) {
  }

  createCurationItem(curationToCreate: any) {
  }
  getCurationCreationData(itemData: { type: string; inputs: IoptionElemet[] }, formName: string) {
  }

  prepareCurationItem(model: any, curationType: string) {
  }

  getCurationItemByKeys(curationToCreate: any) {
  }

  adaptDataToGrid(item: IcurationWorklistItem, currentConf: any, currentUserOrgId: string) {
    CurationUtils.adaptCurationDataToGrid(item, currentConf, currentUserOrgId);
    CurationUtils.setEvidenceDisplayString(item);
  }

  adaptDataToGridWithGrantedAction(item: IcurationWorklistItem, currentUserOrgId: string, actionGrantedForType: boolean) {
    CurationUtils.adaptDataToGridWithGrantedAction(item, currentUserOrgId, actionGrantedForType);
    CurationUtils.setEvidenceDisplayString(item);
  }

  loadAddItemOptions(conf, newItemOptions: any[], curationTypeByFormName: Map<string, any>, loadFormFunc, context) {
  }

  getAddButtonName() {
    return '';
  }

  getMockList() {
    const tempList: Array<any> = [];
    for (let i = 1; i < 100; i++) {
      tempList.push({ aberrationKey: i.toString(), status: CurationSettings.CURATION_STATUS_DRAFT, lastUpdated: i});
    }
    return Observable.of(tempList);
  }

  getCloningEnabled(): boolean {
    return true;
  }

  updateDataFromModel(form: any, content: any, isClonedFromAnotherOrg: boolean, grantedActionsTable?:any){
    Object.keys(form).forEach(((key) => {
      content[key] = form[key];
    }));
  }
}
